import { useEffect, useState } from 'react';
import { listCrops, type BackendCrop } from '../api/crop';

// One request per HTX scope for the whole session — every crop picker on a page
// shares it instead of each fetching the same list.
const cache = new Map<string, Promise<BackendCrop[]>>();

function loadCrops(htxId?: string): Promise<BackendCrop[]> {
  const key = htxId ?? '';
  let pending = cache.get(key);
  if (!pending) {
    pending = listCrops(htxId).catch((err) => {
      cache.delete(key);
      throw err;
    });
    cache.set(key, pending);
  }
  return pending;
}

/** Active crops from the admin "Cây trồng" catalog: GLOBAL ones plus the HTX's
 * own. `null` while loading. */
export function useCrops(htxId?: string): BackendCrop[] | null {
  const [crops, setCrops] = useState<BackendCrop[] | null>(null);
  useEffect(() => {
    let cancelled = false;
    loadCrops(htxId)
      .then((rows) => { if (!cancelled) setCrops(rows); })
      .catch(() => { if (!cancelled) setCrops([]); });
    return () => { cancelled = true; };
  }, [htxId]);
  return crops;
}
